import { EPromoType, IPromoInfo } from '../../../../../types/newbuilding/promoInfo';

export function isMortgageButtonVisible(promoInfo: IPromoInfo) {
  const isPartner = promoInfo.bank?.isPartner || false;

  return isPartner || promoInfo.promoType === EPromoType.CianMortgage;
}
